function e(t) {
  return t && [t.street, t.city, t.state, t.zipCode].filter(Boolean).join(", ") || "";
}
export {
  e as default
};
